module.exports = __webpack_public_path__ + "static/media/linkedin.f4ef6a05.svg";